import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { IScope } from 'angular';

@Component({
    selector: 'downgraded-connection-properties-list',
    templateUrl: './downgraded-connection-properties-list.component.html',
})

/**
 * Bridge between Angular and AngularJS to use connection properties lists in the later.
 * Simply provides proper inputs and outputs, adapts ControlValueAccessor structure and propagates changes.
 * 
 * @example
 * // In AngularJS code
 * <ng2-connection-properties-list [(items)]="items"></ng2-connection-properties-list>
 */
export class DowngradedConnectionPropertiesListComponent {
    @Input() items: Array<Object>;
    @Input() sortable: boolean;
    @Output() onAdd = new EventEmitter<number>();
    @Output() onDelete = new EventEmitter<number>();
    @Output() onChange = new EventEmitter<Array<Object>>();
    @Output() itemsChange = new EventEmitter<Array<Object>>();
    @Output() onValidityChange = new EventEmitter<boolean>();
    @Input() addLabel: string = 'Add Property';
    @Input() hasDivider: boolean = true;
    @Input() focusOnEnter: boolean = true;
    @Input() keyPlaceholder: string = 'Property name';
    @Input() valuePlaceholder: string = 'Property value';
    @Input() canBeFinal: boolean = false;
    @Input() keyRequired: boolean = true;
    @Input() valueRequired: boolean = true;
    @Input() required: boolean = true;
    @Input() keyIdentifier: string = 'name';
    @Input() valueIdentifier: string = 'value';

    constructor(@Inject('$rootScope') private $rootScope: IScope) { 
        this.onValidityChange.subscribe(() => $rootScope.$applyAsync());
    }

    handleChange(items: Array<Object>) {
        this.$rootScope.$applyAsync();
        this.itemsChange.emit(items);
        this.onChange.emit(items);
    }
}
